var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"search-input",attrs:{"label":"URL","solo":"","readonly":""},domProps:{"value":_vm.inputValue}}),_c('TextButton',{staticClass:"ml-2",attrs:{"buttonText":_vm.$store.getters.t('복사'),"iconBackgroundColor":"black","copyText":_vm.inputValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }